import { gettext } from "@/plugins/gettext"
const { $gettext } = gettext

export const siteTypes = {
  1: "MM",
  2: "MB",
  3: "Matching",
  4: "Retargeting",
}

export const langTypes = [
  { id: "en_US", name: "en" },
  // { id: "fr_FR", name: "fr" },
]

export const roleTypes = [
  { id: "Dashboard", displayName: "Dashboard" },
  { id: "Campagne", displayName: "Campagne" },
  { id: "Campagne Inter", displayName: "Campagne Inter" },
  { id: "Salon", displayName: "Salon" },
  { id: "Contact", displayName: "Contact" },
  { id: "Billing", displayName: $gettext("Billing") },
  { id: "Settings", displayName: $gettext("Settings") },
]

export const siteList = [
  {
    id: 1,
    acronym: "MM",
    name: "Meilleurs Masters",
    siteUrl: import.meta.env.VITE_SITE_MM,
  },
  {
    id: 3,
    acronym: "MB",
    name: "Meilleurs Bachelors",
    siteUrl: import.meta.env.VITE_SITE_MB,
  },
  {
    id: 5,
    acronym: "BOC",
    name: "BO Commercial",
    siteUrl: import.meta.env.VITE_SITE_BOC,
  },
  {
    id: 6,
    acronym: "BOE",
    name: "Survey Back Office",
    siteUrl: import.meta.env.VITE_SITE_BOE,
  },
]

export const IS_MM_REPORTS_LIST = 0
export const IS_MB_REPORTS_LIST = 0
export const IS_ALL_REPORTS_LIST = 1